import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

export const useMatch = createRouterSelector((state) => state.match);
